// utils/location.ts

export const getLocation = () => {
  const url = new URL(window.location.href);

  return {
    path: url.pathname,
    fullPath: `${url.pathname}${url.search}${url.hash}`,
    search: url.search,
    hash: url.hash,
    query: Object.fromEntries(url.searchParams),
    searchParams: url.searchParams,
  };
};

export const setQueryParam = (name: string, value: string | number) => {
  const url = new URL(window.location.href);

  url.searchParams.set(name, String(value));

  window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);

  return `${url.pathname}${url.search}${url.hash}`;
};

export const getQueryParam = (name?: string): string | null => {
  if (!name) return null;

  return new URLSearchParams(window.location.search).get(name);
};

export const getPageUrl = (pagingKey: string, page: string | number): string => {
  const url = new URL(window.location.href);

  if (+page === 1) {
    return `${url.pathname}${url.hash}`;
  }

  url.searchParams.set(pagingKey, String(page));

  return `${url.pathname}${url.search}${url.hash}`;
};

export const replaceQueryParam = (name: string, value: string | number): string => {
  const url = new URL(window.location.href);

  url.searchParams.set(name, String(value));

  let fullPath = `${url.pathname}${url.search}${url.hash}`;

  if (+value === 1) {
    fullPath = `${url.pathname}${url.hash}`;
  }

  window.history.replaceState(window.history.state, '', fullPath);

  return fullPath;
};

export const replaceUrl = (urlValue: string): string => {
  const url = new URL(urlValue, window.location.origin);
  const fullPath = `${url.pathname}${url.search}${url.hash}`;

  window.history.replaceState(window.history.state, '', fullPath);

  return fullPath;
};
